import {fetchBaseQuery, type FetchBaseQueryArgs} from "@reduxjs/toolkit/query/react";

const fetchBaseQueryArgs: FetchBaseQueryArgs = {
	baseUrl: `${import.meta.env.VITE_API_BASE}`,  // todo set to server IP
	credentials: "include"
} satisfies FetchBaseQueryArgs;
// console.log("🔍 VITE_API_BASE:", import.meta.env.VITE_API_BASE);

const rtkBaseQuery = fetchBaseQuery(fetchBaseQueryArgs);
export const baseQuery = rtkBaseQuery;
